<template>
  <!-- <v-layout>
      <h1>Fixed Cost #{{$route.params.id}}</h1>
  </v-layout>-->
  <v-col pl-2 pt-2 pr-2  align="center">
    <v-flex xl6 lg8 md12 sm12 xs12 pb-8>
        <SimpleCard>
          <v-layout row wrap align-content-center justify-center>
            <v-flex v-if="loading" xs12 pa-2 class="text-xs-center">
              <v-progress-circular :size="48" :width="5" color="primary" indeterminate></v-progress-circular>
            </v-flex>
            <TransactionSummaryList
              v-if="!loading"
              @search="search"
              :query="query"
              style="width: 100%;"
              :transactions="transactions"
              :paginationProp="pagination"
              :rideTypes="rideTypes"
              @reload="getTransactions"
            ></TransactionSummaryList>
            <v-flex v-if="!loading" pt-2 xs9 class="text-xs-center pt-2">
              <v-pagination @input="changePage" v-model="pagination.page" :length="num_pages"></v-pagination>
            </v-flex>
          </v-layout>
        </SimpleCard>
    </v-flex>
  </v-col>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
import TransactionSummaryList from "@/components/transaction/TransactionSummaryList.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

import moment from "moment";

export default {
  name: "transactions",
  components: {
    SimpleCard,
    TransactionSummaryList,
  },
  data: function () {
    return {
      bookings: [],
      offset: 0,
      count: 25,
      query: {
        idQuery: "",
        before: "",
        after: "",
        driverQuery: ""
      },
      loading: true,
      pagination: { page: 1 },
      num_pages: 0,
      rideTypes: [],
    };
  },
  mounted: async function () {
    if (this.$route.query.bookingID) {
      this.query.bookingID = this.$route.query.bookingID;
      this.query.before = "";
      this.query.state = "all";
    }

    if (this.$route.query.contact_number) {
      this.query.number = this.$route.query.contact_number;
      this.query.before = "";
      this.query.state = "all";
    }

    if (this.$route.query.name) {
      this.query.name = this.$route.query.name;
      this.query.before = "";
      this.query.state = "all";
    }

    this.getTransactions();
  },
  methods: {
    search: function () {
      this.pagination.page = 1;
      this.getTransactions();
    },
    changePage: function (page) {
      this.pagination.page = page;
      console.log(page);
      this.getTransactions();
    },
    getTransactions: async function () {
      this.loading = true;

      try {
        var url;

        // if (this.query.bookingID == null || this.query.bookingID == "") {
        url = `${this.$store.state.apiUrl}/invoice/driver/transactions?offset=${
          this.count * (this.pagination.page - 1)
        }&count=${this.count}`;

        if (this.query.before != null && this.query.before != '') {
          url += `&before=${
          this.query.before
        }`
        }

         if (this.query.after != null && this.query.after != '') {
          url += `&after=${
          this.query.after
        }`
         }

        if (this.query.driverQuery != null && this.query.driverQuery != "") {
          url += `&driverQuery=${this.query.driverQuery}`;
        }

        if (this.query.idQuery != null && this.query.idQuery != "") {
          url += `&idQuery=${this.query.idQuery}`;
        }

        let response = await axios.get(url, {
          params: {},
        });

        var transactions = response.data.transactions.invoice_payment;
        this.transactions = transactions;

        // this.pagination.page = response.data.pages.page;
        this.num_pages = response.data.transactions.num_pages;

        console.log(response.data.transactions.num_pages);

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get transactions " + error);
      }
    },
    failed: function (data) {
      alert("Request Failed with error: " + data.message);
    },
  },
};
</script>


<style lang="scss">

  .v-select .v-input__icon--append {
    display: none;
  }
</style>